export const firebaseConfig = {
    apiKey: "AIzaSyDNdwmiGvMt9qbYVpGVZLhR_NNzl8JyoU4",
    authDomain: "info-med-27bf9.firebaseapp.com",
    databaseURL: "https://info-med-27bf9.firebaseio.com",
    projectId: "info-med-27bf9",
    storageBucket: "info-med-27bf9.appspot.com",
    messagingSenderId: "217732096380",
    appId: "1:217732096380:web:20991e7e1e13738a56c4f9"
};